import { MEMBER_IDS } from './memberIds.const'

/** Member types in TYPE_DEF. String keys only. */
export const MEMBER_TYPES = new Set<string>(MEMBER_IDS)
